class RadioFormElementController {
  constructor() {
    this.name = 'radioFormElement';
  }
}

export default RadioFormElementController;
